// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-title {\n  background: var(--v-green-base);\n  background: linear-gradient(90deg, var(--v-green-base) 25%, #95c14a 100%);\n}\n.modal-content {\n  max-height: 675px;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
